const initialState = {
  senhaVisivel: {},
  login: {
    email: '',
    senha: ''
  },
  cadastro: {
    Nome: '',
    Sobrenome: '',
    Email: '',
    Celular: '',
    Empresa: '',
    Pais: '',
    Estado: '',
    Cidade: '',
    Segmento: '',
    Idioma: '',
    Senha: '',
    SenhaConfirma: '',
    termos: '',
    novidades: '',
  },
  esqueciSenha: {
    email: ''
  },
  recuperarSenha: {
    senha: '',
    senhaConfirmar: ''
  },
  erro: {},
  disabledItem: {
    Email: false, 
    cadastrar: true
  }
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SENHA_VISIVEL':
      return { ...state, senhaVisivel: {...state.senhaVisivel, [payload.name]: payload.value} }
    case 'LOGIN_CHANGE_INFO':
      return { ...state, login: {...state.login, [payload.name]: payload.value} }
    case 'LOGIN_CHANGE_ESQUECI':
      return { ...state, esqueciSenha: {...state.esqueciSenha, [payload.name]: payload.value} }
    case 'LOGIN_CHANGE_RECUPERAR':
      return { ...state, recuperarSenha: {...state.recuperarSenha, [payload.name]: payload.value} }
    case 'LOGIN_ERROR':
      return { ...state, erro: {...state.erro, ...payload} }
    case 'CADASTRAR_CHANGE_INFO':
      return { ...state, cadastro: {...state.cadastro, [payload.name]: payload.value} }
    case 'DISABLED_ITEM':
      return { ...state, disabledItem: {...state.disabledItem, [payload.name]: payload.value} }
    default:
      return state
  }
}
